import createCss from './createCss'

export {createCss as create}
const css = createCss()
export default css
